import * as p from "react";
import { useFloating as fe, offset as me, shift as he, flip as ue, size as ge, arrow as we, hide as xe, limitShift as Pe } from "../../../../../@floating-ui_react-dom@2.1.6_react-dom@19.2.4_react@19.2.4__react@19.2.4/bundled_deps/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
import { Root as ye } from "../../../../../@radix-ui_react-arrow@1.1.7_@types_react-dom@19.2.3_@types_react@19.2.14__@types_react@_e05f2c19a58a99fddf374207b5e3778c/bundled_deps/@radix-ui/react-arrow/dist/index.js";
import { useComposedRefs as z } from "../../../../../@radix-ui_react-compose-refs@1.1.2_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-compose-refs/dist/index.js";
import { createContextScope as Ae } from "../../../../../@radix-ui_react-context@1.1.2_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-context/dist/index.js";
import { Primitive as I } from "../../../../../@radix-ui_react-primitive@2.1.3_@types_react-dom@19.2.3_@types_react@19.2.14__@types_re_1181ea5061ec9212248424669240e4ec/bundled_deps/@radix-ui/react-primitive/dist/index.js";
import { useCallbackRef as ve } from "../../../../../@radix-ui_react-use-callback-ref@1.1.1_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-use-callback-ref/dist/index.js";
import { useLayoutEffect as W } from "../../../../../@radix-ui_react-use-layout-effect@1.1.1_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-use-layout-effect/dist/index.js";
import { useSize as Ce } from "../../../../../@radix-ui_react-use-size@1.1.1_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-use-size/dist/index.js";
import { j as f } from "../../../../../../../_virtual/jsx-runtime.js";
import { autoUpdate as Se } from "../../../../../@floating-ui_dom@1.7.6/bundled_deps/@floating-ui/dom/dist/floating-ui.dom.js";
var R = "Popper", [Y, Fe] = Ae(R), [Re, M] = Y(R), X = (e) => {
  const { __scopePopper: i, children: n } = e, [s, a] = p.useState(null);
  return /* @__PURE__ */ f.jsx(Re, { scope: i, anchor: s, onAnchorChange: a, children: n });
};
X.displayName = R;
var D = "PopperAnchor", F = p.forwardRef(
  (e, i) => {
    const { __scopePopper: n, virtualRef: s, ...a } = e, t = M(D, n), r = p.useRef(null), u = z(i, r), o = p.useRef(null);
    return p.useEffect(() => {
      const c = o.current;
      o.current = s?.current || r.current, c !== o.current && t.onAnchorChange(o.current);
    }), s ? null : /* @__PURE__ */ f.jsx(I.div, { ...a, ref: u });
  }
);
F.displayName = D;
var b = "PopperContent", [be, Oe] = Y(b), k = p.forwardRef(
  (e, i) => {
    const {
      __scopePopper: n,
      side: s = "bottom",
      sideOffset: a = 0,
      align: t = "center",
      alignOffset: r = 0,
      arrowPadding: u = 0,
      avoidCollisions: o = !0,
      collisionBoundary: c = [],
      collisionPadding: g = 0,
      sticky: m = "partial",
      hideWhenDetached: x = !1,
      updatePositionStrategy: P = "optimized",
      onPlaced: d,
      ...l
    } = e, Z = M(b, n), [C, U] = p.useState(null), q = z(i, (w) => U(w)), [S, G] = p.useState(null), O = Ce(S), J = O?.width ?? 0, E = O?.height ?? 0, K = s + (t !== "center" ? "-" + t : ""), Q = typeof g == "number" ? g : { top: 0, right: 0, bottom: 0, left: 0, ...g }, N = Array.isArray(c) ? c : [c], V = N.length > 0, y = {
      padding: Q,
      boundary: N.filter(Ne),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: V
    }, { refs: ee, floatingStyles: _, placement: te, isPositioned: A, middlewareData: h } = fe({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: K,
      whileElementsMounted: (...w) => Se(...w, {
        animationFrame: P === "always"
      }),
      elements: {
        reference: Z.anchor
      },
      middleware: [
        me({ mainAxis: a + E, alignmentAxis: r }),
        o && he({
          mainAxis: !0,
          crossAxis: !1,
          limiter: m === "partial" ? Pe() : void 0,
          ...y
        }),
        o && ue({ ...y }),
        ge({
          ...y,
          apply: ({ elements: w, rects: H, availableWidth: ce, availableHeight: pe }) => {
            const { width: le, height: de } = H.reference, v = w.floating.style;
            v.setProperty("--radix-popper-available-width", `${ce}px`), v.setProperty("--radix-popper-available-height", `${pe}px`), v.setProperty("--radix-popper-anchor-width", `${le}px`), v.setProperty("--radix-popper-anchor-height", `${de}px`);
          }
        }),
        S && we({ element: S, padding: u }),
        _e({ arrowWidth: J, arrowHeight: E }),
        x && xe({ strategy: "referenceHidden", ...y })
      ]
    }), [$, re] = L(te), j = ve(d);
    W(() => {
      A && j?.();
    }, [A, j]);
    const oe = h.arrow?.x, ne = h.arrow?.y, ae = h.arrow?.centerOffset !== 0, [ie, se] = p.useState();
    return W(() => {
      C && se(window.getComputedStyle(C).zIndex);
    }, [C]), /* @__PURE__ */ f.jsx(
      "div",
      {
        ref: ee.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ..._,
          transform: A ? _.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ie,
          "--radix-popper-transform-origin": [
            h.transformOrigin?.x,
            h.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...h.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ f.jsx(
          be,
          {
            scope: n,
            placedSide: $,
            onArrowChange: G,
            arrowX: oe,
            arrowY: ne,
            shouldHideArrow: ae,
            children: /* @__PURE__ */ f.jsx(
              I.div,
              {
                "data-side": $,
                "data-align": re,
                ...l,
                ref: q,
                style: {
                  ...l.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: A ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
k.displayName = b;
var B = "PopperArrow", Ee = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, T = p.forwardRef(function(i, n) {
  const { __scopePopper: s, ...a } = i, t = Oe(B, s), r = Ee[t.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ f.jsx(
      "span",
      {
        ref: t.onArrowChange,
        style: {
          position: "absolute",
          left: t.arrowX,
          top: t.arrowY,
          [r]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[t.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[t.placedSide],
          visibility: t.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ f.jsx(
          ye,
          {
            ...a,
            ref: n,
            style: {
              ...a.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
T.displayName = B;
function Ne(e) {
  return e !== null;
}
var _e = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(i) {
    const { placement: n, rects: s, middlewareData: a } = i, r = a.arrow?.centerOffset !== 0, u = r ? 0 : e.arrowWidth, o = r ? 0 : e.arrowHeight, [c, g] = L(n), m = { start: "0%", center: "50%", end: "100%" }[g], x = (a.arrow?.x ?? 0) + u / 2, P = (a.arrow?.y ?? 0) + o / 2;
    let d = "", l = "";
    return c === "bottom" ? (d = r ? m : `${x}px`, l = `${-o}px`) : c === "top" ? (d = r ? m : `${x}px`, l = `${s.floating.height + o}px`) : c === "right" ? (d = `${-o}px`, l = r ? m : `${P}px`) : c === "left" && (d = `${s.floating.width + o}px`, l = r ? m : `${P}px`), { data: { x: d, y: l } };
  }
});
function L(e) {
  const [i, n = "center"] = e.split("-");
  return [i, n];
}
var ke = X, Be = F, Te = k, Le = T;
export {
  Be as Anchor,
  Le as Arrow,
  Te as Content,
  X as Popper,
  F as PopperAnchor,
  T as PopperArrow,
  k as PopperContent,
  ke as Root,
  Fe as createPopperScope
};
